import colors from "theme/theme-light/colors";

const { text } = colors;

const buttonText = {
  textPrimary: {
    color: text.textLink,
    background:"transparent",
    "&:hover": {
      color: text.textLink,
      background:"transparent",
    },
  },

  textSuccess: {
    color: text.textPositive,
    background:"transparent",
    "&:hover": {
      color: text.textPositive,
      background:"transparent",
    },
  },

  textError: {
    color: text.textNegative,
    background:"transparent",
    "&:hover": {
      color: text.textNegative,
      background:"transparent",
    },
  },

  textWarning: {
    color: text.textWarning,
    background:"transparent",
    "&:hover": {
      color: text.textWarning,
      background:"transparent",
    },
  },
};

export default buttonText;
